export default "__VITE_ASSET__BaUW3c0p__"